export function loadMstv(wrapper, edtn, isMstv, isAutoPlay, isYoutube) {
  if (isAutoPlay || (isMstv && (edtn == 'de' || edtn == 'ev_de'))) {
    appendIframe(wrapper.dataset.videoUrl);
  } else {
    wrapper.addEventListener('click', (event) => {
      appendIframe(wrapper.dataset.videoUrl);
    });
  }

  function appendIframe(url) {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('allowfullscreen', 'allowfullscrean');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('src', url);
    wrapper.appendChild(iframe);
  }
}
